import React, { useEffect, useState } from "react";
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import  DateTime  from 'react-datetime';
import NumberFormat from "react-number-format";
import moment from "moment";
import Swal from "sweetalert2";

const Cobranca = ({ formulario, setFormulario, onClose, cobIdx }) => {
  
  const initialCob = {
    nDup: { _text: '' },
    dVenc: { _text: '' },
    vDup: { _text: '' },
  };	

  const [listaCobranca, setListaCobranca] = useState(initialCob);
  const [nFat, setNfat] = useState('');

  useEffect(() => {
    let frm = formulario;      

    if(frm.dadosNota.cobr == undefined){
      frm.dadosNota.cobr = {dup: [], fat: {nFat: { _text: '' }}};
      setNfat(frm.dadosNota.cobr.fat.nFat._text);
    }

    if ((cobIdx != null)&& (cobIdx != -1)) {     
      
      frm.dadosNota.cobr.dup.map(dup=>{
        if(dup.idx == cobIdx){
          setListaCobranca(dup);
        }
      })
    }

    if((frm.dadosNota.cobr) && (frm.dadosNota.cobr.fat) && (frm.dadosNota.cobr.fat.nFat)){
      setNfat(frm.dadosNota.cobr.fat.nFat._text);
    }
  }, []);
  
  const onChangeCobranca = (e, campo) =>{
    setListaCobranca(prev => ({ ...prev, [campo]: { _text: e } }));
  }

  const onChangeDate = (e, name) => {
    let valor = '';

    if (e.length != undefined) {
      if ((e.length == 2) || (e.length == 5)) {
        valor = e + '/';
      } else {
        valor = e;
      }
    } else {
      valor = e.format('YYYY-MM-DD');
    }
    onChangeCobranca(valor,'dVenc')
  }

  const gravarCobranca = () =>{
    // V-06: valida vencimento após data de emissão
    if (listaCobranca.dVenc._text) {
      const dEmi = formulario.dadosNota.ide && formulario.dadosNota.ide.dhEmi
        ? formulario.dadosNota.ide.dhEmi._text
        : null;
      if (dEmi && moment(listaCobranca.dVenc._text).isBefore(moment(dEmi), 'day')) {
        Swal.fire('Atenção', 'A data de vencimento não pode ser anterior à data de emissão da nota.', 'warning');
        return;
      }
    }

    let frm = { ...formulario, dadosNota: { ...formulario.dadosNota } };

    if(frm.dadosNota.cobr.fat && frm.dadosNota.cobr.fat.nFat._text == ''){
      frm.dadosNota.cobr = { ...frm.dadosNota.cobr, fat: { nFat: { _text: nFat } } };
    }

    if(cobIdx == -1){
      const novaDup = { ...listaCobranca, idx: frm.dadosNota.cobr.dup.length, nDup: { _text: (frm.dadosNota.cobr.dup.length + 1).toString() } };
      frm.dadosNota.cobr = { ...frm.dadosNota.cobr, dup: [...frm.dadosNota.cobr.dup, novaDup] };
    }else{
      frm.dadosNota.cobr = {
        ...frm.dadosNota.cobr,
        dup: frm.dadosNota.cobr.dup.map(dup => dup.idx == cobIdx ? { ...listaCobranca, idx: dup.idx } : dup)
      };
    }

    setFormulario(frm);
    onClose();
  }

  const onChangeNfat = (e) =>{
    let fat = nFat;
    fat = e;
    setNfat(fat);
  }

  const removerCobranca = () =>{
    let frm = formulario;
    let idx = 0;

    frm.dadosNota.cobr.dup.map((dup, index)=>{
      if(dup.idx == cobIdx){
        idx = index;
      }
    })

    frm.dadosNota.cobr.dup.splice(idx,1);
    setFormulario(frm);
    onClose();
  }

  return (
    <>    
      <ModalHeader>Edição de Boleto de Cobrança da NF-e</ModalHeader>

      <ModalBody>
        <Row>
          <Col>
            <FormGroup>
              <Label for="cod_barras">Nº Documento</Label>
              <Input
                className="inputSM"
                name="cod_barras"
                id="cod_barras"
              //onBlur={onChange('cod_barras')}
                defaultValue={nFat}                         
                onChange={(e)=>{onChangeNfat(e.target.value)}} 
                disabled = {nFat == '' ? false : true}
              />
            </FormGroup>
          </Col>

          <Col>
            <FormGroup>
              <Label for="tabloide_id">Vencimento</Label>
              <DateTime
                value={listaCobranca.dVenc._text != '' ? moment(listaCobranca.dVenc._text).format('DD/MM/YYYY') : ''}
                dateFormat="DD/MM/YYYY"
                onChange={onChangeDate}
                timeFormat={false}
                closeOnSelect={true}
              // inputProps={{ disabled: configFieldDetPromo.inicio_promocao }}
              >
              </DateTime>
            </FormGroup>
          </Col>

          <Col md="4">
            <FormGroup>
              <Label for="preco_escalonado">Valor</Label>
              <NumberFormat
                className="form-control"
                name="preco_escalonado"
                id="preco_escalonado"
                type="text"
                placeholder="0.00"
                //mask="_"
                // format="R$ ###,##"
                prefix={"R$ "}
                decimalSeparator={','}
                //onBlur={onChangeEscalonado('preco_escalonado')}
                value={listaCobranca.vDup._text.replace('.', ',')}
                onChange={(e)=>{onChangeCobranca(e.target.value.replace('R$ ','').replace(',','.'),'vDup')}}
                fixedDecimalScale
                
              />
            </FormGroup>
          </Col>

        </Row>

      </ModalBody>

      <ModalFooter>
        <Row>
          <Col className="mr-2">
            <Button className="bg-success" onClick={gravarCobranca}>Gravar</Button>
            <Button className="bg-info" onClick={removerCobranca}>Remover</Button>
            <Button className="bg-danger" onClick={onClose}>Fechar</Button>
          </Col>
        </Row>

      </ModalFooter>

    </>
  );
};

export default Cobranca;